import(/* webpackMode: "eager" */ "/tmp/8de7485a103134a/app/[locale]/error.tsx");
